import { render, staticRenderFns } from "./FileModal.vue?vue&type=template&id=1a271d13&scoped=true&"
import script from "./FileModal.vue?vue&type=script&lang=ts&"
export * from "./FileModal.vue?vue&type=script&lang=ts&"
import style0 from "./FileModal.vue?vue&type=style&index=0&id=1a271d13&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a271d13",
  null
  
)

export default component.exports